document.addEventListener('DOMContentLoaded', () => {
    const filters = document.querySelectorAll('.filters .filter');
    const items = document.querySelectorAll('.investments__items .investments__item');

    filters.forEach(filter => {
        filter.addEventListener('click', () => {
            const selected = filter.getAttribute('data-filter');

            // Ustaw aktywny element
            filters.forEach(f => f.classList.remove('active'));
            filter.classList.add('active');

            if (selected === 'all') {
                items.forEach(item => {
                    item.classList.remove('hide');
                    item.classList.add('show');
                });
            } else {
                items.forEach(item => {
                    const itemFilters = item.getAttribute('data-filter');
                    if (itemFilters && itemFilters.split(' ').includes(selected)) {
                        item.classList.remove('hide');
                        item.classList.add('show');
                    } else {
                        item.classList.add('hide');
                        item.classList.remove('show');
                    }
                });
            }
        });
    });
});
